@if (maintenance() && !dismissed()) {
  <p-message
    class="block p-3"
    styleClass="w-full"
    icon="pi pi-info-circle"
    [severity]="maintenance()?.severity"
    [text]="maintenance()?.message"
    [closable]="true"
    (onClose)="dismiss()"
  >
  </p-message>
}
